/**
 * JSON.stringify that never throws. A plain `JSON.stringify` blows up on circular references
 * (and BigInt values), and when that happens inside a React render it unmounts the whole app
 * (blank white page). This is used to render case/run detail panels defensively.
 */
export function safeStringify(value: unknown, space: number = 2): string {
  const seen = new WeakSet<object>()
  try {
    return JSON.stringify(
      value,
      (_key, val) => {
        if (typeof val === 'bigint') return val.toString()
        if (typeof val === 'object' && val !== null) {
          if (seen.has(val)) return '[Circular]'
          seen.add(val)
        }
        return val
      },
      space
    )
  } catch (err) {
    return `Unable to display details: ${err instanceof Error ? err.message : 'serialization error'}`
  }
}
